import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getQueryKey as companyNotesGetQueryKey } from '@/components/Note/hooks/useCompanyNotes';
import { getQueryKey as noteGetQueryKey } from '@/components/Note/hooks/useNote';

import { mutationFn } from './mutationFn';
import { getQueryKey as noteRemindersGetQueryKey } from '../utils';

/**
 * This hook can be used to delete a note reminder
 * @returns {Object}
 *  - `mutate` a function which can be called to delete a note reminder
 *  - `status` a flag to indicate state of the request
 */
export const useDeleteNoteReminder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn,
    onSettled: (_, __, { companyId, noteId }) => {
      const COMPANY_NOTES_QUERY_KEY = companyNotesGetQueryKey(companyId);
      const NOTE_QUERY_KEY = noteGetQueryKey(noteId);
      const NOTE_REMINDERS_QUERY_KEY = noteRemindersGetQueryKey(noteId);

      queryClient.invalidateQueries({ queryKey: COMPANY_NOTES_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: NOTE_REMINDERS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: NOTE_QUERY_KEY });
    },
  });
};
